import type { GalleryProductBase } from '../types'
import { VpIcon } from '@vtmn-play/react'
import { useTranslation } from 'react-i18next'
import './product-sustainability.scss'

const statusClassNames = {
  neutral: 'product-sustainability--neutral',
  success: 'product-sustainability--success',
  negative: 'product-sustainability--negative',
} as const

export function ProductSustainability({
  eco_designed,
  co2_environmental_impact,
}: Readonly<{
  eco_designed: GalleryProductBase['eco_designed']
  co2_environmental_impact: GalleryProductBase['co2_environmental_impact']
}>) {
  const { t } = useTranslation()

  const getName = (eco_designed: boolean | null) => {
    if (eco_designed === null) {
      return 'subtract'
    }
    return eco_designed ? 'check' : 'close'
  }

  const getStatus = (eco_designed: boolean | null) => {
    if (eco_designed === null) {
      return 'neutral'
    }
    return eco_designed ? 'success' : 'negative'
  }

  const getLabel = (eco_designed: boolean | null) => {
    if (eco_designed === null) {
      return t('products-page.product-card.ecodesign.undefined')
    }
    return t(`products-page.product-card.ecodesign.${eco_designed ? 'true' : 'false'}`)
  }

  return (
    <section
      className="product-card-sustainability"
      data-testid="product-card_sustainability"
    >
      <div className="product-sustainability">
        <div className={statusClassNames[getStatus(eco_designed)]}>
          <VpIcon name={getName(eco_designed)} />
          {getLabel(eco_designed)}
        </div>
        {co2_environmental_impact?.total && (
          <div data-testid="product-sustainability_co2">
            <span>
              {co2_environmental_impact.total.toFixed(2)}
              {' '}
              {co2_environmental_impact.unit}
            </span>
          </div>
        )}
      </div>
    </section>
  )
}
